export function editItem(state) {
    return state.editItem;
}

export function getMInterests(state) {
    return state.interests;
}

export function showUploadImageModal(state) {
    return state.uploadImageModal
}